import {FC} from "react";
import {TabTitle, TabBlockAside, TabP, TabTitleDark} from "../../styles";
import ImgArrowRight from "../../../../assets/images/icon-tab-arrow-toright.svg";
import ImgStep1 from "../../../../assets/images/metodology-step1.svg";
import ImgStep2 from "../../../../assets/images/metodology-step2.svg";
import ImgStep3 from "../../../../assets/images/metodology-step3.svg";
import ImgStep7 from "../../../../assets/images/metodology-step7.svg";
import ImgStep8 from "../../../../assets/images/metodology-step8.svg";
import ImgStep9 from "../../../../assets/images/metodology-step9.svg";
export const TabInfoOne: FC = () => {
  return (
    <div>
      <TabTitle style={{color: "rgba(255, 255, 255, 0.6"}}>
        Этапы создания Карты технологий
      </TabTitle>
      <br />
      <TabBlockAside>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
            gap: 50,
          }}
        >
          <div>
            <img width={50} src={ImgStep1} alt="" />
          </div>
          <div style={{width: "100%"}}>
            <TabTitle>Этап 1</TabTitle>
            <TabP>
              Определение технологических направлений (сегментов) на основе
              анализа стратегических документов России и мира.
            </TabP>

            <div
              style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "start",
                gap: 30,
              }}
            >
              <img
                width={50}
                src={ImgArrowRight}
                alt=""
                style={{marginTop: 8}}
              />
              <div>
                <TabTitleDark>Источники</TabTitleDark>
                <TabP>
                  Наднациональные организации, Правительства, структуры,
                  формирующие политику национальной безопасности.
                </TabP>
              </div>
            </div>
          </div>
        </div>
      </TabBlockAside>
      <TabBlockAside>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
            gap: 50,
          }}
        >
          <div>
            <img width={50} src={ImgStep2} alt="" />
          </div>
          <div style={{width: "100%"}}>
            <TabTitle>Этап 2</TabTitle>
            <TabP>
              Загрузка абстрактов препринтов, публикаций, патентов, описаний
              стартапов для выбранного направления.
            </TabP>

            <div
              style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "start",
                gap: 30,
              }}
            >
              <img
                width={50}
                src={ImgArrowRight}
                alt=""
                style={{marginTop: 8}}
              />
              <div>
                <TabTitleDark>Источники</TabTitleDark>
                <TabP>
                  API для Arxiv.org, Google Patents, Роспатент, Google Scholar,
                  Crunchbase, Pitchbook.
                </TabP>
              </div>
            </div>
          </div>
        </div>
      </TabBlockAside>
      <TabBlockAside>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
            gap: 50,
          }}
        >
          <div>
            <img width={50} src={ImgStep3} alt="" />
          </div>
          <div style={{width: "100%"}}>
            <TabTitle>Этап 3</TabTitle>
            <TabP>
              Извлечение упоминаний технологий с помощью экстрактивных и
              генеративных ИИ моделей.
            </TabP>
            <TabTitle>Этап 4</TabTitle>
            <TabP>
              Объединение синонимов и подсчет числа упоминаний для выделения
              ключевых технологий.
            </TabP>
            <TabTitle>Этап 5</TabTitle>
            <TabP>
              Объединение технологий в группы с использованием ИИ модели
              кластеризации.
            </TabP>

            <div
              style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "start",
                gap: 30,
              }}
            >
              <img
                width={50}
                src={ImgArrowRight}
                alt=""
                style={{marginTop: 8}}
              />
              <div>
                <TabTitleDark>Источники</TabTitleDark>
                <TabP>Машинная обработка с использованием ИИ-моделей.</TabP>
              </div>
            </div>
          </div>
        </div>
      </TabBlockAside>
      <TabBlockAside>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
            gap: 50,
          }}
        >
          <div>
            <img width={50} src={ImgStep7} alt="" />
          </div>
          <div style={{width: "100%"}}>
            <TabTitle>Этап 6</TabTitle>
            <TabP>
              Определение атрибутов технологий — соответствие национальным
              приоритетам, критичность и сквозность, объем привлеченных
              инвестиций и проч.
            </TabP>
            <div
              style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "start",
                gap: 30,
              }}
            >
              <img
                width={50}
                src={ImgArrowRight}
                alt=""
                style={{marginTop: 8}}
              />
              <div>
                <TabTitleDark>Источники</TabTitleDark>
                <TabP>
                  Распоряжения Правительства РФ, Указы Президента, аналитическая
                  платформа TeqViser.
                </TabP>
              </div>
            </div>
          </div>
        </div>
      </TabBlockAside>
      <TabBlockAside>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
            gap: 50,
          }}
        >
          <div>
            <img width={50} src={ImgStep8} alt="" />
          </div>
          <div style={{width: "100%"}}>
            <TabTitle>Этап 7</TabTitle>
            <TabP>
              Определение технологических разрывов “Россия – мир” на основе RnD
              активности.
            </TabP>
            <div
              style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "start",
                gap: 30,
              }}
            >
              <img
                width={50}
                src={ImgArrowRight}
                alt=""
                style={{marginTop: 8}}
              />
              <div>
                <TabTitleDark>Источники</TabTitleDark>
                <TabP>Аналитическая платформа TeqViser.</TabP>
              </div>
            </div>
          </div>
        </div>
      </TabBlockAside>
      <TabBlockAside>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
            gap: 50,
          }}
        >
          <div>
            <img width={50} src={ImgStep9} alt="" />
          </div>
          <div style={{width: "100%"}}>
            <TabTitle>Этап 8</TabTitle>
            <TabP>
              Экспертная валидация Карты технологий: кластеры, технологии и
              технологические разрывы.
            </TabP>
            <div
              style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "start",
                gap: 30,
              }}
            >
              <img
                width={50}
                src={ImgArrowRight}
                alt=""
                style={{marginTop: 8}}
              />
              <div>
                <TabTitleDark>Источники</TabTitleDark>
                <TabP>Пул экспертов Газпромбанка и его партнеров.</TabP>
              </div>
            </div>
          </div>
        </div>
      </TabBlockAside>
    </div>
  );
};
